import React from 'react'
import { Link } from 'react-router-dom'
import { publicRoutePaths } from '@/routes/public.routes.config';
import orexLogo from "@/assets/images/svg/orexlogo.svg";

const StepperHeader = ({ percentage }) => {

  return (
    <>
      <header className="stepper-header-wrape">
         <div className="container-fluid">
            <div className="header-inner">
             <div className="brand-wrape">
                          <Link to={publicRoutePaths.HOME.path} className="brand" title="">
                            <img src={orexLogo} alt="OrexTrade" loading="lazy" width={232} height={76} />
                          </Link>
                          {/* <Link to={publicRoutePaths.HOME.path} className="brand small" title="">
                            <img src={orexSymbol} alt="OrexTrade" loading="lazy" width={51} height={48} />
                          </Link> */}
                        </div>
                        </div>
         </div>
        </header>
         <div className='progress'>
            <div className='progress-bar' style={{width: `${percentage == 80 ? 100 : percentage}%`}}></div>
         </div>
      
    </>
  )
}

export default StepperHeader
